export const Types = {
  LOGIN: "LOGIN",
  ADD_USER: "ADD_USER",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_PROFILE_PICTURE: "UPDATE_PROFILE_PICTURE",
  FORM_SUBMITION_STATUS: "FORM_SUBMITION_STATUS",
};
